// @flow
import React from 'react';
import { useFormikContext } from 'formik';
import { setFieldValueToGivenStringAndFieldTouchedToTrue } from '@src/formik-utils/utils';

import { ConfirmModal } from '../presentational/modals/ConfirmModal';
import { RATE_CARD_BACKEND_NAME } from '../../constants';
import { StaticTable } from '../presentational/StaticTable';

import {
  CLUSTER_MAPPING_TABLE_FROM_NEW_TO_OLD,
  CLUSTER_MAPPING_TABLE_FROM_OLD_TO_NEW,
  CONNECT_AND_TABLEFLOW_PRICING_CHANGES_TABLE,
} from './constants';

const EstimateRateCardChangeWarningModal = ({ isOpen, setOpen }) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();

  const header = 'Change in Rate Card';

  const body = (
    <>
      <p>
        <strong>WARNING:</strong>
        <br /> <br />
        The billing model for Kafka, Connect and Tableflow varies across different rate cards, we
        suggest reviewing the information below.
        <ul>
          <li>
            We introduced Tiered Pricing for Connectors and Tableflow through the 5/15/2026 rate
            card. The connector task prices are now buckets across four price points - $0.05, $0.10,
            $0.30 and $3.0 per task.
          </li>
          <li>
            The billing model for Basic and Standard clusters was changed with the launch of eCKU
            based pricing. This pricing is available on the rate card 4/11/2024, 8/14/2025 and
            5/15/2026
          </li>
        </ul>
        Switching rate cards between the 5/15/2026 to ‘4/11/2024 and 8/14/2025’ rate cards will
        result in inclusion/exclusion of tiered pricing. Switching rate cards between ‘4/11/2024 and
        8/14/2025’ rate cards and older rate cards (8/1/2020, 10/1/2020, and 3/5/2020) will result
        in changes to Basic and Standard clusters that may affect the total commit calculation.
        <br /> <br />
        There are no other pricing changes between 5/15/2026 and ‘8/14/2025 and 4/11/2024’ rate
        cards except the tiered pricing and connect task price streamlining. All renewals can
        continue on 4/11 or 3/5 rate cards. All New commits after 6/1/2026 must be on 5/15/2026. If
        an existing customer wants to renew, they can move over to the 5/15/2026 tiered pricing rate
        card.
        <br /> <br />
        Please see the tables below for the details.
        <br />
        <StaticTable tableContents={CLUSTER_MAPPING_TABLE_FROM_OLD_TO_NEW} />
        <StaticTable tableContents={CLUSTER_MAPPING_TABLE_FROM_NEW_TO_OLD} />
        <strong>Note:</strong> Enterprise and Dedicated cluster pricing is same across these rate
        cards and will not be impacted.
        <br /> <br />
        <strong>Connect and Tableflow specific changes</strong>
        <StaticTable tableContents={CONNECT_AND_TABLEFLOW_PRICING_CHANGES_TABLE} />
        <strong>Note:</strong> We do not support 5/15/2026 (Tiered pricing rate card) to older rate
        card transition.
      </p>

      <p>
        If you dont want this behaviour, then, please click
        <strong> No, revert my changes! </strong>
        to go back to the previous state!
      </p>
    </>
  );

  return (
    <ConfirmModal
      body={body}
      cancelButtonText="No, revert my changes!"
      header={header}
      isOpen={isOpen}
      okButtonText="Yes, I understand and want to proceed!"
      onClickHandlerForCancel={async () => {
        // If the User has clicked on cancel, remove the RC selection and force the user to enter it again
        /*
              Note: This was introduced to handle the following bug
              1. Go to an estimate which is of type New Commit
              2. Switch to renewals
              3. Check that RC disappears
              4. Then, click on revert changes
              5. If the user was originally on 4/11, user would continue to be on 4/11 and no error is thrown

              In this fix, we clear out the RC even when the user starts with Renewals ( instead of starting with New Commit and moving to renewals ), but that is okay
           */
        await setFieldValueToGivenStringAndFieldTouchedToTrue(
          RATE_CARD_BACKEND_NAME,
          '',
          setFieldValue,
          setFieldTouched
        );
        setOpen(false);
      }}
      onClickHandlerForOK={() => {
        setOpen(false);
      }}
    />
  );
};

export default EstimateRateCardChangeWarningModal;
